import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import ATTRIBUTE_IDS from '../../../constants/consultants/attributeIds';

export default function UsersWidgets () {
    const formatter = Intl.NumberFormat('es-ES');
    const { t } = useTranslation();

    const checkAttribute = (attributesArray, attributeId) => {
        const filteredAttributes = attributesArray.filter((attribute) => attribute.id_attribute === attributeId);
        const length = filteredAttributes.length;
        return length ? filteredAttributes[length - 1].description : '';
    };

    return [{
        key: 'id',
        dataField: 'id',
        text: t('management.consultants.table.columns.id'),
        sort: false,
        headerClasses: 'clientsColumnsMC_headers--title',
    }, {
        key: 'name_and_surname',
        dataField: 'name_and_surname',
        text: t('management.consultants.table.columns.fullName'),
        sort: false,
        headerClasses: 'clientsColumnsMC_headers--title',
        formatter: (cellContent) => _.startCase(cellContent),
    }, {
        key: 'dni',
        dataField: 'dni',
        text: t('management.consultants.table.columns.document'),
        sort: false,
        headerClasses: 'clientsColumnsMC_headers--title',
        formatter: (cellContent) => formatter.format(cellContent),
    }, {
        key: 'level',
        dataField: 'attributes',
        text: t('management.consultants.table.columns.level'),
        sort: false,
        headerClasses: 'clientsColumnsMC_headers--title',
        formatter: (cellContent) => {
            return checkAttribute(Object.values(cellContent), ATTRIBUTE_IDS.LEVEL);
        },
    }, {
        key: 'gender',
        dataField: 'gender',
        text: t('management.consultants.table.columns.gender'),
        sort: false,
        headerClasses: 'clientsColumnsMC_headers--title',
    }, {
        key: 'time',
        dataField: 'attributes',
        text: t('management.consultants.table.columns.time'),
        sort: false,
        headerClasses: 'clientsColumnsMC_headers--title',
        formatter: (cellContent) => {
            return checkAttribute(Object.values(cellContent), ATTRIBUTE_IDS.TIME);
        },
    }, {
        key: 'sector',
        dataField: 'attributes',
        text: t('management.consultants.table.columns.sector'),
        sort: false,
        headerClasses: 'clientsColumnsMC_headers--title',
        formatter: (cellContent) => {
            return checkAttribute(Object.values(cellContent), ATTRIBUTE_IDS.SECTOR);
        },
    }, {
        key: 'managment',
        dataField: 'attributes',
        text: t('management.consultants.table.columns.management'),
        sort: false,
        headerClasses: 'clientsColumnsMC_headers--title',
        formatter: (cellContent) => {
            return checkAttribute(Object.values(cellContent), ATTRIBUTE_IDS.MANAGEMENT);
        },
    }];
}
